import { render, staticRenderFns } from "./OrgHistoryTable.vue?vue&type=template&id=a31f72cc"
import script from "./OrgHistoryTable.vue?vue&type=script&lang=js"
export * from "./OrgHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports